import React from 'react';
import PsychologyIcon from '@mui/icons-material/Psychology';
import StrategyPage from '../components/legendary/StrategyPage';

export default function LegendaryMinervini() {
  return (
    <StrategyPage
      strategyKey="MINERVINI"
      title="Minervini VCP"
      icon={<PsychologyIcon />}
      color="#8b5cf6"
    />
  );
}
